import t from 'tcomb';

const Com_Locale = t.enums.of('fr_FR en_GB en_US es_ES it_IT en_ZA de_DE pt_BR');

module.exports = Com_Locale;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Com_Locale.js
 **/